import { faClock } from "@fortawesome/pro-duotone-svg-icons/faClock";

import { type Breadcrumb } from "@application/types/breadcrumb";

export const DASHBOARD_SCHEDULES_LINK: Breadcrumb = {
  icon: faClock,
  name: "Schedules",
  to: "/dashboard/triggers/schedules",
};
